import {customElement} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import {unsafeHTML} from "lit/directives/unsafe-html.js";
import {generateUuid} from "../../../common/crypto";
import {RenderedDialogContent, RenderedDialogs} from "../renderedDialogs";

export class CalendarInfoLayerContent extends RenderedDialogContent {

    public constructor(
        dialogId: string,
        public readonly content: string
    ) {
        super(dialogId);
    }
}

@customElement("eop-calendar-info-layers")
export class EopCalendarInfoLayers extends RenderedDialogs<CalendarInfoLayerContent> {

    protected readonly dialogClass = "disclaimer-dialog";

    public constructor() {
        super();
    }

    protected renderDialogContent(content: CalendarInfoLayerContent): TemplateResult {
        return html`${unsafeHTML(content.content)}`;
    }

    public create(
        content: string
    ): string {
        const dialogId = "calendar-info-layer-" + generateUuid();
        this.dialogContents = [...this.dialogContents, new CalendarInfoLayerContent(dialogId, content)];
        return dialogId;
    }
}